import { SnackbarTypes } from './types'

function showSnackbar(type: SnackbarTypes, message?: string) {
  dispatchEvent(
    new CustomEvent('show-snackbar', {
      detail: {
        type: type,
        message: message,
      },
    })
  )
}

export { showSnackbar }
